import { createContext } from "react";
import { ClientDetails, Currency, ItemPricing } from "../../../types";
import { AddressFormType } from "../../../types";
import { OrderDetail } from "../../../types";

type AdminOrderContextType = {
  // Order
  orderDetail?: OrderDetail;
  reducedOrderItems: ItemPricing[];
  onEditItemDesign?: (designId: string) => void;
  onAddNewDesign?: (
    designId: string,
    sizes: any
  ) => Promise<{
    orderDetail: any;
    error: any;
  }>;
  onGoToTechpack?: () => void;
  onUpdateSizesQty?: (designId: string, sizes: any) => Promise<void>;
  onUpdateProjectNumber?: (projectNumber: string) => Promise<void>;
  onUpdatePoNumber?: (poNumber: string) => Promise<void>;
  onUpdateCarbonNeutral?: (carbonNeutral: boolean) => Promise<void>;
  onUpdateClientDetailsField?: (
    field: keyof ClientDetails,
    value: string
  ) => Promise<void>;
  onUpdateShippingAddress?: (address: AddressFormType) => Promise<void>;
  onUpdateBillingAddress?: (address: AddressFormType) => Promise<void>;
  onUpdateDiscounts?: (discounts: any) => Promise<void>;
  onUpdateCurrency?: (currency: Currency) => Promise<void>;
  onRemoveDesign?: (designId: string) => void;
  isOrderLoaded: boolean;
};

export const AdminOrderContext = createContext<AdminOrderContextType>({
  orderDetail: undefined,
  reducedOrderItems: [],
  isOrderLoaded: false,
});
